<template>
  <div>
    <el-form :model="datas" ref="form" :validOnChange="true" :rules="validationRules" label-width="100px">
      <el-form-item label="父节点" prop="pid">
<!--        <treePicker :treePicker="treePicker" style="width: 80%"></treePicker>-->
      </el-form-item>
      <el-form-item label="名称" prop="name">
        <el-input size="small" type="text" v-model="datas.name" style="width: 80%" />
      </el-form-item>
      <el-form-item label="编码" prop="key">
        <el-input size="small" type="text" v-model="datas.key" style="width: 80%" />
      </el-form-item>
      <el-form-item label="配置值" prop="value" >
        <el-input size="small" type="text" v-model="datas.value" style="width: 80%" />
      </el-form-item>
      <el-form-item label="描述" prop="text" class="line-height">
        <el-input type="textarea" v-model="datas.text" placeholder="内容补充" style="width: 80%" />
      </el-form-item>
      <div style="text-align: center">
        <el-button style="width: 150px" type="primary" @click="save()" size="mini">提交</el-button>
        <el-button style="width: 150px; margin-left: 20px" type="danger" @click="close()" size="mini">关闭</el-button>
      </div>
    </el-form>
  </div>
</template>
<script>
export default {
  computed: {
    treePick() {
      return this.$store.state.employee.treePick;
    }
  },
  watch: {
    treePick(old) {
      this.datas.pid = old;
    }
  },
  components: {

  },
  props: {
    params: Object
  },
  data() {
    return {
      validationRules: {
        pid: [{ required: true, message: '请选择父节点', trigger: 'blur' }],
        name: [{ required: true, message: '请输入名称', trigger: 'blur' }],
        key: [{ required: true, message: '请输入编码', trigger: 'blur' }]
      },
      datas: {
        id: null,
        name: null,
        orderNum: null,
        pid: null,
        value: null,
        text: null,
        key: null
      },
      param: {
        keyName: 'id',
        parentName: 'pid',
        titleName: 'name',
        dataMode: 'tree',
        datas: ''
      },
      treePicker: {
        url: `${$api_eap.config.tree}`,
        params: {},
        toLabel: 'name',
        size: 'small'
      }
    };
  },
  mounted() {
    this.tree();
    if (this.params.id != null) {
      this.leftForById();
    }
    this.$store.dispatch('changeNodeName', this.params.teamName);
    this.$store.dispatch('changeTreePick', this.params.teamId);
  },
  methods: {
    close() {
      this.$emit('close');
    },
    success() {
      this.$emit('success', '999');
    },
    tree() {
      httpKit.post($api_eap.config.tree).then(res => {
        if (res.data.code === '200') {
          if (res.data.data.length > 0) {
            this.param.datas = res.data.data;
          }
        }
      });
    },
    change(value) {
      if (value == null || value === 'undefined' || value === '') return;
      let par = value.children;
      if (par === '' || par === null || par === undefined) {
        this.datas.orderNum = 1;
      } else {
        this.datas.orderNum = par.length + 1;
      }
    },
    leftForById() {
      httpKit.post($api_eap.config.info, { configId: this.params.id }).then(res => {
        if (res.data.code === '200') {
          this.datas = res.data.data;
          let obj = findInTree(this.params.tree, res.data.data.pid, 'id');
          this.$store.dispatch('changeNodeName', obj.label);
          this.$store.dispatch('changeTreePick', this.datas.pid);
        }
      });
    },
    async save() {
      if (this.datas.pid === null) {
        this.$message.error('请选择父节点');
        return;
      }
      let res = await this.$refs.form.validate();
      if (!res) {
        return;
      }
      const loading = this.$loading({
        lock: true,
        text: '保存中，请稍等',
        spinner: 'el-icon-loading'
      });
      httpKit.post($api_eap.config.save, this.datas).then(res => {
        loading.close();
        if (res.data.code === '200') {
          this.$message.success(res.data.msg);
          this.success();
        } else {
          this.$message.error(res.data.msg);
        }
      });
    }
  }
};
</script>
<style lang="less" scoped>
.el-form-item {
  width: 80%;
  margin: 0 auto;
  margin-bottom: 20px;
}
.line-height /deep/ .el-form-item__label {
  line-height: 40px !important;
}
</style>
